

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();

  // State variables for menu toggles
  const [isVideoLibrary, setIsVideoLibrary] = useState(false);
  const [isBillingOpen, setIsBillingOpen] = useState(false); // State for toggling Billing submenu
  const [iscurrentState, setIscurrentState] = useState("VideoLibrary");
  const [isVideoProcessor, setIsVideoProcessor] = useState(false);
  // Function to update the icon sidebar state
  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "VideoLibrary") {
      setIsVideoLibrary(false);
    }
    if (iscurrentState !== "Billing") {
      setIsBillingOpen(false);
    }
    if (iscurrentState !== "VideoProcessor") {
      setIsVideoProcessor(false);
    }
  }, [iscurrentState]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "video-library",
      label: "DAM",
      icon: "bx bx-layer",
      link: "/dam",
      stateVariables: isVideoLibrary,
      click: function (e) {
        e.preventDefault();
        history("/dam");
        setIsVideoLibrary(!isVideoLibrary);
        setIscurrentState("VideoLibrary");
        updateIconSidebar(e);
      },
    },
    {
      id: "video-processor",
      label: "Video Processor",
      icon: "bx bx-layout",
      link: "/video-processor",
      stateVariables: isVideoProcessor,
      click: function (e) {
        e.preventDefault();
        history("/video-processor");
        setIsVideoProcessor(!isVideoProcessor);
        setIscurrentState("VideoProcessor");
        updateIconSidebar(e);
      },
    },
    {
      id: "live-streaming",
      label: "Live Streaming",
      labelSubtitle: "(Coming Soon)",
      icon: "bx bx-video",
      link: "#",
      isDisabled: true,
      click: function (e) {
        e.preventDefault();
        // Do nothing - menu item is disabled
      },
    },
    {
      id: "billing",
      label: "Billing",
      icon: "bx bx-wallet",
      link: "/billing",
      stateVariables: isBillingOpen,
      click: function (e) {
        e.preventDefault();
        setIsBillingOpen(!isBillingOpen); // Toggle the Billing submenu
        setIscurrentState("Billing");
        updateIconSidebar(e);
      },
      stateVariables: isBillingOpen,
      subItems: [
        {
          id: "current-plan",
          label: "Current Plan",
          link: "/billing/current-plan",
          parentId: "billing",
        },
        {
          id: "billing-details",
          label: "Billing Details",
          link: "/billing/billing-details",
          parentId: "billing",
        },
        {
          id: "invoices",
          label: "Invoices",
          link: "/billing/invoices",
          parentId: "billing",
        },
      ],
    },
  ];

  return (
    <React.Fragment>
      {menuItems}
    </React.Fragment>
  );
};

export default Navdata;
